<template>
  <DealerPrice
    :disable="isQuoteAccepted"
    :has-pricing="hasPricing"
    :dealers-price="dealersPrice"
    @select:price="priceSelected"
    @close="close"
  />
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import { getEnv } from 'ecx.saigon.ui.common';

export default {
  name: 'DealerPriceWidget',
  metaInfo: {
    title: 'Dealer Pricing |'
  },
  data() {
    return {
      updateApplicationPaths:
        this.$Constants.APPLICATION_UPDATE_PATHS.dealerPrice
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.quote.quote.status,
      dealersPrice: (state) => state.quote.dealersPrice || []
    }),
    ...mapGetters('application', ['isQuoteAccepted']),
    hasPricing() {
      return (
        this.status === this.$Constants.QUOTE_STATUSES.PRICINGRECEIVED.value
      );
    }
  },
  methods: {
    ...mapActions('quote', ['getDealersPrice', 'createQuote']),
    ...mapMutations('quote', ['setPrice']),
    async priceSelected() {
      try {
        await this.createQuote({
          componentContext: this,
          updateApplicationPaths: this.updateApplicationPaths
        });
        await this.$router.push({
          name: this.$RouteNames.summary,
          params: { ...this.$router.currentRoute.params }
        });
      } catch (err) {}
    },
    async close() {
      const env = await getEnv();
      window.location = env.VUE_APP_CORE_ROUTE;
    }
  },
  beforeMount() {
    if (this.hasPricing) {
      this.$router.push({
        name: this.$RouteNames.summary,
        params: { ...this.$router.currentRoute.params }
      });
    }
  },
  components: {
    DealerPrice: () => import('../../components/page/dealer-price')
  }
};
</script>
